var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"md":"1","align-self":"center"}},[(_vm.onhover)?_c('v-card',{attrs:{"height":"450","width":"200"}}):_vm._e(),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.clicked()}}},[_c('v-icon',[_vm._v("fa fa-plus")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }